
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Calendar, AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface BookingLinkSectionProps {
  formData: {
    google_calendar_link: string;
  };
  onInputChange: (field: string, value: string) => void;
}

export default function BookingLinkSection({ formData, onInputChange }: BookingLinkSectionProps) {
  const hasBookingLink = formData.google_calendar_link && formData.google_calendar_link.trim() !== '';

  return (
    <div className="border-2 border-blue-200 p-6 rounded-lg bg-blue-50">
      <div className="flex items-center gap-2 mb-4">
        <Calendar className="h-6 w-6 text-blue-600" />
        <Label htmlFor="google_calendar_link" className="text-xl font-bold text-blue-800">
          Booking Link (Required for Publishing)
        </Label>
      </div>
      
      {!hasBookingLink && (
        <Alert className="mb-4 border-amber-200 bg-amber-50">
          <AlertCircle className="h-4 w-4 text-amber-600" />
          <AlertDescription className="text-amber-800">
            A booking link is required before this expert can be published to the marketplace.
          </AlertDescription>
        </Alert>
      )}
      
      <div className="space-y-3">
        <Input
          id="google_calendar_link"
          placeholder="https://calendar.app.google/... or your preferred booking platform"
          value={formData.google_calendar_link || ''}
          onChange={(e) => onInputChange('google_calendar_link', e.target.value)}
          className={`text-lg ${!hasBookingLink ? 'border-amber-300 focus:border-amber-500' : 'border-blue-300 focus:border-blue-500'}`}
        />
        
        <div className="text-sm space-y-2">
          <p className="text-blue-700 font-medium">
            This link will be used by clients to book consultations with this expert.
          </p>
          <div className="text-blue-600">
            <p className="font-medium">Supported platforms:</p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Google Calendar Appointment Slots</li>
              <li>Calendly</li>
              <li>Acuity Scheduling</li>
              <li>Any other booking platform</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
